import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ordActions } from "src/context/order-slice";
import { getOrderFuidDetails } from "src/services/order-api";
import OrderInfoFuidCard from "./OrderInfoTabCards/OrderInfoFuidCard";
import { RootState } from "src/context/store";
import { useSelector } from "react-redux";
import { Spinner } from "src/components";
import { toast } from "src/hooks/useToast";
import InfiniteScroll from "react-infinite-scroll-component";

const OrderInfoFuid = () => {
  const { OrderFuidDetails } = useSelector((state: RootState) => state.ord);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const order_id_int = window.sessionStorage.getItem("order_id_int") ? Number(window.sessionStorage.getItem("order_id_int")) : null;
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(2);
  const limit = 10;

  const fetchMoreData = async () => {
    if (isLoading) return;
    const order_id_int = window.sessionStorage.getItem("order_id_int") ? Number(window.sessionStorage.getItem("order_id_int")) : null;

    try {
      setPage((prevPage) => prevPage + 1);

      const res = await getOrderFuidDetails(order_id_int, page, limit);

      if (!res?.data?.data || res?.data?.data?.length === 0) {
        setHasMore(false);
        return;
      }
      const uniqueNewData = res?.data?.data;

      if (uniqueNewData.length === 0) {
        setHasMore(false);
        return;
      }

      dispatch(ordActions.setOrderFuidDetails(OrderFuidDetails ? [...OrderFuidDetails, ...uniqueNewData] : uniqueNewData));
    } catch (error) {
      console.error("Error fetching more data:", error);
      toast({
        variant: "destructive",
        description: "Failed to load more fuid",
      });
      setHasMore(false);
    } finally {
    }
  };

  const fetchFuidDetails = async () => {
    setIsLoading(true);

    try {
      const res = await getOrderFuidDetails(order_id_int, 1, 10);
      toast({ description: "Fuid details fetched successfully", variant: "default" });
      dispatch(ordActions.setOrderFuidDetails(res?.data?.data));
    } catch (error: any) {
      console.log(error);
      toast(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFuidDetails();
  }, []);

  return (
    <div>
      {isLoading ? (
        <div className="flex justify-center items-center h-[50vh]">
          <Spinner />
        </div>
      ) : OrderFuidDetails?.length && OrderFuidDetails.length > 0 ? (
        <div
          id="scrollableDiv"
          className="h-[calc(100vh-250px)] overflow-auto overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
        >
          <InfiniteScroll
            dataLength={OrderFuidDetails?.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              <div className="flex justify-center py-4">
                <Spinner />
              </div>
            }
            scrollableTarget="scrollableDiv"
            endMessage={<div className="py-4 text-center text-gray-500">No more fuid to load</div>}
          >
            {OrderFuidDetails?.map((fuid: any, index: number) => (
              <OrderInfoFuidCard key={fuid?.attachment_order_lnk_id} fuid={fuid} index={index} />
            ))}
          </InfiniteScroll>
        </div>
      ) : (
        <h1 className="text-center text-gray-500 text-lg h-[50vh] flex items-center justify-center">No fuid found</h1>
      )}
    </div>
  );
};

export default OrderInfoFuid;
